/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type HappeningEdit_happening$ref: FragmentReference;
declare export opaque type HappeningEdit_happening$fragmentType: HappeningEdit_happening$ref;
export type HappeningEdit_happening = {|
  +id: string,
  +title: string,
  +url: string,
  +imageUrl: ?string,
  +startDate: any,
  +endDate: any,
  +description: ?string,
  +details: ?string,
  +callToAction: ?string,
  +store: ?{|
    +id: string
  |},
  +$refType: HappeningEdit_happening$ref,
|};
export type HappeningEdit_happening$data = HappeningEdit_happening;
export type HappeningEdit_happening$key = {
  +$data?: HappeningEdit_happening$data,
  +$fragmentRefs: HappeningEdit_happening$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HappeningEdit_happening",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "imageUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "details",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "callToAction",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Store",
      "kind": "LinkedField",
      "name": "store",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "HeroOffer"
};
})();
// prettier-ignore
(node/*: any*/).hash = '77bbef9e9787e64f0b8ffc4acc895c12';

module.exports = node;
